import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faHome, faTachometerAlt, faClipboardList, faUsers, faSignOutAlt, faBell, faEnvelope, faUserCircle, faCaretDown,faChartBar  } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import {  Badge, Menu, MenuItem, Divider, Typography } from "@mui/material";
import {  faExclamationCircle, faXmarkCircle, faCheckCircle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Modal } from "@mui/material";

// Styled Components
const Topbars = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px;
  background-color: #3b1675; 
  //background-color: #4D8983; 
  color: white;
  z-index: 1000;

  h3 {
    margin: 0;
    display: flex;
    align-items: center;
    color: black; 
  }

  img {
    width: 30px; /* Adjust size as needed */
    height: auto;
    margin-right: 10px; /* Space between the image and the heading */
  }

  div {
    margin-left: auto; /* This will push the div containing buttons to the right */
  }
`;

const NavbarContainer = styled.div`
  position: fixed;
  top: 80px;
  left: 0;
  width: 200px;
  height: calc(100% - 55px);
  background-color: #ececea; 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-200px)')};
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
  z-index: 999;
  overflow-y: auto;

  @media (min-width: 768px) {
    transform: translateX(0);
  }
`;


const NavItems = styled.nav`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 30px;
`;

const NavLink = styled(Link)`
  text-decoration: none;
  color: #020202; /* Default text color */
  padding: 15px 10px;
  text-align: left;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease, font-size 0.3s ease;

  &:hover {
    // background-color: #df447d; 
    background-color: #18267a; 
    color: white; /* Change text color on hover */
    font-size: 18px; /* Increase font size on hover */
  }
`;

const Icon = styled(FontAwesomeIcon)`
  margin-right: 10px;
`;

const Dropdown = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  background-color: #ececec;
  padding-left: 30px; /* Add left padding for dropdown items */
`;

const DropdownLink = styled(Link)`
  text-decoration: none;
  color: #020202;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease, font-size 0.3s ease;

  &:hover {
    background-color: #18267a;
    color: white;
    font-size: 18px;
  }
`;

const ToggleButton = styled.button`
  background-color: black;
  border: none;
  color: white;
  padding: 10px 10px;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  margin-right: 30px;

  @media (min-width: 768px) {
    display: none;
  }

  &:hover {
    background-color: #333; 
  }

  &:active {
    transform: scale(0.95); /* Slightly reduce size when active */
  }
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
  margin-right: 15px;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 20px;
  margin-right: 15px;

  @media (max-width: 760px) {
    display: none; /* Hide icon buttons on smaller screens */
  }
`;

const MobileIconButton = styled.button`
  background: none;
  border: none;
  color: black; /* Change to black for mobile */
  cursor: pointer;
  font-size: 16px; 
  text-decoration: none;
  
  padding: 15px 20px;
  text-align: left;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease, font-size 0.3s ease;

  &:hover {
    background-color: #18267a; 
    color: white; /* Change text color on hover */
    font-size: 18px; /* Increase font size on hover */
  }

  &:hover {
    background-color: #e0e0e0; // Change background color on hover
  }
`;

const IconText = styled.span`
  margin-left: 8px; // Space between icon and text
`;

const Navbardashboard = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isapplicantsDropdownOpen, setIsapplicantsDropdownOpen] = useState(false);
  const [isemployerDropdownOpen, setIsemployerDropdownOpen] = useState(false); // New state for employer dropdown
  const [isreportDropdownOpen, setIsreportDropdownOpen] = useState(false); // New state for report dropdown
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleNavbar = () => {
    setIsNavbarOpen(prevState => !prevState);
  };

  const toggleapplicantsDropdown = () => {
    setIsapplicantsDropdownOpen(prevState => !prevState);
  };

  const toggleemployerDropdown = () => {  // Toggle function for employer dropdown
    setIsemployerDropdownOpen(prevState => !prevState);
  };

  const togglereportDropdown = () => {  // Toggle function for report dropdown
    setIsreportDropdownOpen(prevState => !prevState);
  };

  const handleLinkClick = (path) => {
    setIsNavbarOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    console.log('Logged out');
    navigate('/'); // Redirect to login page
  };

  return (
    <>
      <Topbars>
        <h3 className='text-white p-2'>
          <span className="bg-white text-indigo-900 p-2 rounded-full">JM</span>
          <span className='text-white p-2'>    JOB MARKET</span>
        </h3>
        <div>
          {/* Icon buttons visible in desktop view */}
          <IconButton aria-label="Profile" onClick={() => navigate('/profile')}>
            <FontAwesomeIcon icon={faUserCircle} />
          </IconButton>
          {/* <IconButton aria-label="Notifications" onClick={() => navigate('/notifications')}>
            <FontAwesomeIcon icon={faBell} />
          </IconButton> */}
           <IconButton aria-label="Notifications" onClick={handleOpen}>
        <Badge badgeContent={4} color="primary">
          <FontAwesomeIcon icon={faBell} />
        </Badge>
      </IconButton>

      {/* Notification Dropdown */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem disabled>
          <Typography variant="subtitle1" component="div">
            You have 4 new notifications
          </Typography>
        </MenuItem>
        <Divider />

        {/* Notification Items */}
        <MenuItem onClick={handleClose}>
          <FontAwesomeIcon icon={faExclamationCircle} className="text-warning" />
          <div className="ml-2">
            <Typography variant="body1" component="div">
              Lorem Ipsum
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Quae dolorem earum veritatis oditseno
            </Typography>
            <Typography variant="caption" color="textSecondary">
              30 min. ago
            </Typography>
          </div>
        </MenuItem>
        <Divider />

        <MenuItem onClick={handleClose}>
          <FontAwesomeIcon icon={faXmarkCircle} className="text-danger" />
          <div className="ml-2">
            <Typography variant="body1" component="div">
              Atque rerum nesciunt
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Quae dolorem earum veritatis oditseno
            </Typography>
            <Typography variant="caption" color="textSecondary">
              1 hr. ago
            </Typography>
          </div>
        </MenuItem>
        <Divider />

        <MenuItem onClick={handleClose}>
          <FontAwesomeIcon icon={faCheckCircle} className="text-success" />
          <div className="ml-2">
            <Typography variant="body1" component="div">
              Sit rerum fuga
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Quae dolorem earum veritatis oditseno
            </Typography>
            <Typography variant="caption" color="textSecondary">
              2 hrs. ago
            </Typography>
          </div>
        </MenuItem>
        <Divider />

        <MenuItem onClick={handleClose}>
          <FontAwesomeIcon icon={faInfoCircle} className="text-primary" />
          <div className="ml-2">
            <Typography variant="body1" component="div">
              Dicta reprehenderit
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Quae dolorem earum veritatis oditseno
            </Typography>
            <Typography variant="caption" color="textSecondary">
              4 hrs. ago
            </Typography>
          </div>
        </MenuItem>
        <Divider />

        {/* Footer */}
        <MenuItem onClick={() => navigate("/notifications")}>
          <Typography variant="body2" color="primary">
            Show all notifications
          </Typography>
        </MenuItem>
      </Menu>
          <IconButton aria-label="Messages" onClick={() => navigate('/messages')}>
            <FontAwesomeIcon icon={faEnvelope} />
          </IconButton>
          {/* Show logout button only on desktop view */}
          {!isMobile && (
            <LogoutButton aria-label="Logout" onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} />
            </LogoutButton>
          )}
          <ToggleButton aria-label="Toggle navbar" onClick={toggleNavbar}>
            <FontAwesomeIcon icon={isNavbarOpen ? faTimes : faBars} />
          </ToggleButton>
        </div>
      </Topbars>

      <NavbarContainer isOpen={isNavbarOpen}>
      <NavItems>
          <NavLink to="/" onClick={() => handleLinkClick('/')}>
            <Icon icon={faHome} />
            Home
          </NavLink>
          <NavLink >
            <Icon icon={faTachometerAlt} />
            Dashboard
          </NavLink>
          <NavLink >
            <Icon icon={faClipboardList} />
            JOB LIST
          </NavLink>
          
          {/* applicants Dropdown with a caret */}
          <NavLink to="#" onClick={toggleapplicantsDropdown}>
            <Icon icon={faUsers} />
            APPLICANTS
            <FontAwesomeIcon icon={faCaretDown} style={{ marginLeft: 'auto' }} />
          </NavLink>
          <Dropdown isOpen={isapplicantsDropdownOpen}>
            <DropdownLink >
              APPROVAL
            </DropdownLink>
            <DropdownLink >
              APPLICANTS
            </DropdownLink>
          </Dropdown>

          {/* employer Dropdown */}
          <NavLink to="#" onClick={toggleemployerDropdown}>
            <Icon icon={faUsers} />
            EMPLOYER
            <FontAwesomeIcon icon={faCaretDown} style={{ marginLeft: 'auto' }} />
          </NavLink>
          <Dropdown isOpen={isemployerDropdownOpen}>
            <DropdownLink >
              ADD EMPLOYER
            </DropdownLink>
            <DropdownLink >
              ALL EMPLOYER
            </DropdownLink>
          </Dropdown>

          {/* report Dropdown */}
          <NavLink to="#" onClick={togglereportDropdown}>
            <Icon icon={faChartBar} />
            REPORT
            <FontAwesomeIcon icon={faCaretDown} style={{ marginLeft: 'auto' }} />
          </NavLink>
          <Dropdown isOpen={isreportDropdownOpen}>
            <DropdownLink  >
              MONTHLY  
            </DropdownLink>
            <DropdownLink >
             ANNUAL
            </DropdownLink>
          </Dropdown>

        <NavLink to="/" onClick={() => handleLinkClick('/')}>
            <Icon icon={faSignOutAlt} />
            LOGOUT
          </NavLink>
           
          {/* Icon buttons for mobile view in the vertical navbar */}
          {/* {isMobile && (
            <>
              <MobileIconButton aria-label="Profile" >
                <FontAwesomeIcon icon={faUserCircle} />
                <IconText>Profile</IconText>
              </MobileIconButton>
              <MobileIconButton aria-label="Notifications" >
                <FontAwesomeIcon icon={faBell} />
                <IconText>Notifications</IconText>
              </MobileIconButton>
              <MobileIconButton aria-label="Messages" >
                <FontAwesomeIcon icon={faEnvelope} />
                <IconText>Messages</IconText>
              </MobileIconButton>
              <MobileIconButton aria-label="Logout" to="/" onClick={() => handleLinkClick('/')}>
                <FontAwesomeIcon icon={faSignOutAlt} />
                <IconText>Logout</IconText>
              </MobileIconButton>
            </>
          )} */}
        </NavItems>
      </NavbarContainer>
    </>
  );
};

export default Navbardashboard;
